const state = {
    activeItems: [],
    layout: [],
    sidebar: [],
    activeSection: '',
    defaultLayout: [],
}

const getters = {
    getActiveItems: state => state.activeItems,
    getLayout: state => state.layout,
    getSidebar: state => state.sidebar,
    getActiveSection: state => state.activeSection,
    getDefaultLayout: state => state.defaultLayout,
}

const mutations = {
    setActiveItems: (state, items) => {
        state.activeItems = items
    },
    setLayout: (state, items) => {
        state.layout = items
    },
    setSidebar: (state, items) => {
        state.sidebar = items
    },
    setActiveSection: (state, items) => {
        state.activeSection = items
    },
    setDefaultLayout: (state, items) => {
        state.defaultLayout = items
    },
}

const actions = {
    setActiveItems({ dispatch, commit, state }, data) {
        commit('setActiveItems', data)
    },
    setLayout({ dispatch, commit, state }, data) {
        commit('setLayout', data)
    },
    setSidebar({ dispatch, commit, state }, data) {
        commit('setSidebar', data)
    },
    setActiveSection({ dispatch, commit, state }, data) {
        commit('setActiveSection', data)
    },
    setDefaultLayout({ dispatch, commit, state }, data) {
        commit('setDefaultLayout', data)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
